(() => {
  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('[data-smooth-scroll-target]');
      if (!trigger) {
        return;
      }

      const selector = trigger.dataset.smoothScrollTarget;
      if (!selector) {
        return;
      }

      const target = document.querySelector(selector);
      if (!target) {
        return;
      }

      event.preventDefault();
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });
    },
    true
  );
})();
